import gql from 'graphql-tag';
// Use this when you just need a name and an id for a partner link. This has a quick load time
// This is used in situations where we need to just get a name and an ID for a partner link instead of all the extra stuff
// that causes a lot of load time.
export const GET_PARTNER_LINKS_LIGHTWEIGHT = gql`
  query GetPartnerLinksLightweight($dynamicsId: ID!) {
    getPartnerLinksLightweight(dynamicsId: $dynamicsId) {
      partnerLinkId
      dynamicsPartnerAccountId
      dynamicsPartnerLinkId
      accountId
      accountName
    }
  }
`;
